<template>
  <div class="CollectionGrid">
    <div
      v-for="(design, index) of designs"
      :key="index"
      class="collectionitem"
      @click="() => handleClick(design)"
      @dragend="() => handleClick(design)"
    >
      <div class="innerContent">
        <img :src="design.thumbnail.replace(/^https?:/, '')" />
        <base-icon
          v-if="design.selected"
          class="check-icon absolute pin-r object-right-top rounded-full"
          name="check-icon"
          size="xs"
        />
      </div>
      <div
        v-if="design.label"
        :data-selected="design.selected"
        class="labelContent"
      >
        {{ design.label }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CollectionGrid',
  props: {
    designs: {
      type: Array,
      required: true
    }
  },
  methods: {
    handleClick(design) {
      this.$emit('item-clicked', design);
    }
  }
};
</script>
<style lang="scss" scoped>
.CollectionGrid {
  @apply flex flex-wrap -mb-4;
  .collectionitem {
    @apply block float-none w-full cursor-pointer border p-1;
    flex-basis: 31%;
    margin: 1%;
    &:hover {
      @apply border-sh-primary;
    }
    .innerContent {
      @apply relative w-full;
      padding-bottom: 100%;

      img {
        @apply absolute w-full h-full;
        background: linear-gradient(to bottom right, #eee 0%, #ccc 100%);
        object-fit: scale-down;
      }
    }

    .labelContent {
      @apply block mr-0 text-center float-none relative pt-1;
      background-color: rgba(255, 255, 255, 0.8);
    }

    .check-icon {
      background-color: #ffffff;
      padding: 0.25rem;
      display: flex;
      bottom: 5px;
      right: 5px;
      box-shadow: 0px 0px 9px rgb(0 0 0 / 20%);
    }
  }
}
</style>
